import consumer from './consumer';

consumer.subscriptions.create('NotificationsChannel', {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    const $counter = $('#notification-counter');
    const $counterLabel = $('#notification-label');
    let val;
    $('#notifications_menu').prepend(data.message);

    if ($counter.text()) {
      val = parseInt($counter.text(), 10);
    } else {
      val = 0;
    }
    val += 1;
    $counterLabel
      .css({
        opacity: 0,
      })
      .animate(
        {
          opacity: 1,
        },
        1200
      );
    $counter
      .css({
        opacity: 0,
      })
      .text(val)
      .animate(
        {
          opacity: 1,
        },
        1200
      );
  },
});
